var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRootuser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1804_1266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 12.25C13 13.0456 13.3161 13.8087 13.8787 14.3713C14.4413 14.9339 15.2044 15.25 16 15.25C16.7956 15.25 17.5587 14.9339 18.1213 14.3713C18.6839 13.8087 19 13.0456 19 12.25C19 11.4544 18.6839 10.6913 18.1213 10.1287C17.5587 9.56607 16.7956 9.25 16 9.25C15.2044 9.25 14.4413 9.56607 13.8787 10.1287C13.3161 10.6913 13 11.4544 13 12.25Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 22.75V21.25C11.5 20.4544 11.8161 19.6913 12.3787 19.1287C12.9413 18.5661 13.7044 18.25 14.5 18.25H14.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3499 22.6128L18.7209 23.4663C18.6726 23.4914 18.6182 23.5027 18.5639 23.4987C18.5095 23.4947 18.4573 23.4758 18.4131 23.4439C18.3689 23.412 18.3345 23.3684 18.3136 23.3181C18.2927 23.2677 18.2863 23.2126 18.2949 23.1588L18.6062 21.3505L17.2884 20.0703C17.2491 20.0322 17.2213 19.9839 17.2081 19.9308C17.1949 19.8777 17.1969 19.822 17.2139 19.77C17.2308 19.718 17.2621 19.6718 17.304 19.6367C17.346 19.6016 17.397 19.579 17.4512 19.5715L19.2722 19.3075L20.0867 17.6628C20.111 17.6138 20.1486 17.5726 20.1951 17.5437C20.2416 17.5149 20.2952 17.4997 20.3499 17.4997C20.4046 17.4997 20.4583 17.5149 20.5048 17.5437C20.5513 17.5726 20.5888 17.6138 20.6132 17.6628L21.4277 19.3075L23.2487 19.5715C23.3027 19.5793 23.3535 19.602 23.3953 19.6372C23.4371 19.6723 23.4682 19.7184 23.4851 19.7703C23.502 19.8222 23.5041 19.8778 23.4911 19.9308C23.4781 19.9838 23.4505 20.0321 23.4114 20.0703L22.0937 21.3505L22.4042 23.158C22.4135 23.2119 22.4075 23.2673 22.3869 23.318C22.3663 23.3687 22.3319 23.4126 22.2876 23.4447C22.2433 23.4768 22.1909 23.4958 22.1364 23.4996C22.0818 23.5034 22.0273 23.4919 21.9789 23.4663L20.3499 22.6128Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1804_1266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRootuser);
export default __webpack_public_path__ + "static/media/rootuser.a0ec481a1abf5f1b19059bb946674d95.svg";
export { ForwardRef as ReactComponent };